export default "__VITE_ASSET__f324ecaf__"